import React from 'react';
import Link from 'next/link';
import Reveal from '@/components/ui/Reveal';
import { AUTHOR_NAME, SITE_NAME, AUTHOR_URL } from '@/config';
import { HeartIcon } from '@/components/ui/Icons';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    const footerLinks = [
        { label: 'About Us', href: '/about' },
        { label: 'Privacy Policy', href: '/privacy-policy' },
        { label: 'Terms of Service', href: '/terms-of-service' },
        { label: 'Contact Us', href: '/contact' },
    ];

    const AuthorCredit = AUTHOR_URL ? (
        <a href={AUTHOR_URL} target="_blank" rel="noopener noreferrer" aria-label={`${AUTHOR_NAME}'s profile (opens in new tab)`} className="font-semibold text-orange-400 hover:underline transition-colors">
            {AUTHOR_NAME}
        </a>
    ) : (
        AUTHOR_NAME
    );

    return (
        <Reveal as="footer" className="text-center text-slate-400 py-6 sm:py-8 mt-12 border-t border-white/10">
            <div className="flex justify-center mb-6">
                <Link href="/" prefetch={false} className="transition-transform duration-300 hover:scale-105" aria-label={`${SITE_NAME} homepage`}>
                    <div className="logo-text text-4xl sm:text-5xl">
                        {SITE_NAME}
                    </div>
                </Link>
            </div>

            <nav className="flex justify-center flex-wrap gap-x-6 gap-y-2 mb-8">
                {footerLinks.map(link => (
                    <Link key={link.label} href={link.href} prefetch={false} className="text-slate-300 hover:text-orange-400 transition-colors duration-300 font-medium">
                        {link.label}
                    </Link>
                ))}
            </nav>

            <div className="border-t border-white/10 pt-6">
                <p>© {currentYear} <Link href="/" prefetch={false} className="font-semibold text-orange-400 hover:underline transition-colors">{SITE_NAME}</Link>. All Rights Reserved. | Made with <HeartIcon className="heart pulse w-4 h-4 inline-block align-middle mx-1" style={{ color: '#ef4444' }} /> by {AuthorCredit}</p>
            </div>
        </Reveal>
    );
};

export default React.memo(Footer);